<template>
  <InputPopupModule
    :show="show"
    :title="title"
    :subtitle="subtitle"
    :hideActions="false"
    :saveLabel="setupLabel"
    :cancelLabel="continueLabel"
    :initial-data="{}"
    :validation-fn="() => true"
    @save="handleSetup"
    @cancel="handleContinue"
    @update:show="$emit('update:show', $event)">
    <template #content>
      <!-- Info Message -->
      <div class="flex flex-col gap-5 py-3">
        <!-- Icon and Message -->
        <div class="flex items-start gap-3">
          <InfoIcon class="h-5 w-5 text-blue-500 flex-shrink-0 mt-0.5" />

          <div class="flex-1 space-y-3">
            <p class="text-sm text-[var(--color-text)] leading-relaxed">
              {{ message }}
            </p>

            <!-- Example if provided -->
            <div
              v-if="example"
              class="bg-[var(--color-primary-100)] rounded px-3 py-2 text-xs text-[var(--color-text)]">
              <span class="opacity-70">{{ $t('common.example') }}</span>
              <span class="font-mono ml-2 opacity-90">{{ example }}</span>
            </div>
          </div>
        </div>

        <!-- Don't Show Again Checkbox -->
        <label
          class="flex items-center gap-2.5 cursor-pointer text-xs text-[var(--color-text)] opacity-80 hover:opacity-100 transition pt-3 border-t border-[var(--color-primary-300)]">
          <input
            v-model="dontShowAgain"
            type="checkbox"
            class="w-4 h-4 rounded border-[var(--color-primary-400)] text-[var(--color-accent)] focus:ring-2 focus:ring-[var(--color-accent)]" />
          <span>{{ $t('common.dontShowAgain') }}</span>
        </label>
      </div>
    </template>
  </InputPopupModule>
</template>

<script setup>
  import { ref } from 'vue'
  import { InfoIcon } from 'lucide-vue-next'
  import InputPopupModule from '@/components/ui/inputs/InputPopupModule.vue'

  defineProps({
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      required: true,
    },
    example: {
      type: String,
      default: '',
    },
    setupLabel: {
      type: String,
      default: '',
    },
    continueLabel: {
      type: String,
      default: '',
    },
  })

  const emit = defineEmits(['update:show', 'setup', 'continue'])

  const dontShowAgain = ref(false)

  function handleSetup() {
    emit('setup', dontShowAgain.value)
  }

  function handleContinue() {
    emit('continue', dontShowAgain.value)
  }
</script>
